import React from "react";
import { Plus } from "lucide-react";
import { displayPrice } from "../lib/format";
import PlaceholderTile from "./PlaceholderTile";

const BADGE_STYLES = {
  New: "bg-sapore-purple text-sapore-cream",
  Spicy: "bg-red-600 text-white",
  "Best Seller": "bg-sapore-gold text-sapore-ink",
};

export default function MenuCard({ item, index, onOpen }) {
  const soldOut = item.sold_out;
  return (
    <div
      data-testid={`menu-item-card-${item.id}`}
      onClick={() => !soldOut && onOpen(item)}
      className={`group bg-white rounded-2xl overflow-hidden border border-sapore-border transition-all duration-300 ${
        soldOut ? "opacity-70 cursor-not-allowed" : "cursor-pointer hover:-translate-y-1 hover:shadow-xl"
      }`}
    >
      <div className="relative aspect-[4/3] overflow-hidden">
        {item.image_url ? (
          <img
            src={item.image_url}
            alt={item.name}
            loading="lazy"
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          />
        ) : (
          <PlaceholderTile />
        )}
        <div className="absolute top-2 left-2 flex flex-wrap gap-1">
          {(item.badges || []).map((b) => (
            <span key={b} className={`text-[10px] font-bold uppercase tracking-widest px-2 py-0.5 rounded-full ${BADGE_STYLES[b] || "bg-sapore-purple text-white"}`}>
              {b}
            </span>
          ))}
        </div>
        {soldOut && (
          <div className="absolute inset-0 bg-sapore-ink/50 flex items-center justify-center">
            <span data-testid={`sold-out-badge-${item.id}`} className="bg-white/95 text-sapore-purple font-bold uppercase tracking-widest text-sm px-4 py-1.5 rounded-full rotate-[-6deg] border-2 border-sapore-purple">
              Sold Out
            </span>
          </div>
        )}
      </div>
      <div className="p-4">
        <div className="flex items-start justify-between gap-2">
          <h3 className="font-serif text-lg font-semibold text-sapore-ink leading-tight">{item.name}</h3>
        </div>
        {item.description && <p className="text-sm text-sapore-muted mt-1 line-clamp-2">{item.description}</p>}
        <div className="flex items-center justify-between mt-3">
          <span className="text-lg font-bold text-sapore-gold">{displayPrice(item)}</span>
          <button
            data-testid={`add-to-cart-button-${item.id}`}
            disabled={soldOut}
            onClick={(e) => {
              e.stopPropagation();
              onOpen(item);
            }}
            className="flex items-center gap-1 bg-sapore-purple text-sapore-cream text-sm font-medium pl-3 pr-4 py-2 rounded-full hover:bg-sapore-purpleDark transition-colors disabled:opacity-50 hover:scale-[1.03] active:scale-[0.97]"
          >
            <Plus size={16} /> Add
          </button>
        </div>
      </div>
    </div>
  );
}
